import { SquadDto } from '@scale/shared/types/expertManagement';
import { useQuery } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFetchSquadsForUser = (userId: string) => {
  return useQuery(
    ['fetchSquadsForUser', userId],
    () =>
      apiFetch<{ squads: SquadDto[] }>(null, `internal/expert-management/squadsForUser/${userId}`, {
        method: 'GET',
      }),
    {
      refetchOnWindowFocus: false,
    },
  );
};
